import { Stack, Typography } from '@mui/material';
import { VyDescriptionTitle } from '../../../../../../../../../../components/new-design/data-display/VyDescriptionTitle/VyDescriptionTitle.tsx';
import { FC } from 'react';
import { isNotNullOrUndefined } from '@vy/utils';
import { VyDivider } from '../../../../../../../../../../components/new-design/atoms';
import { formatDate } from '@vy/date';
import { VyLinearProgress } from '../../../../../../../../../../components/new-design/data-display/VyLinearProgress/VyLinearProgress.tsx';
import { CREDIT_KINDS, CREDIT_SCHEDULES, CreditSchedule, CURRENCIES, type Currency } from '@vy/types';
import { formatCreditAmount } from './format-credit-amount';

type CreditsTrackerProps = {
  totalCredits: number;
  usedCredits: number;
  resetDate?: Date | null;
  schedule?: CreditSchedule;
  currency?: Currency;
  creditKind?: string;
  units?: string;
};

export const CreditsTracker: FC<CreditsTrackerProps> = ({
  totalCredits,
  usedCredits,
  resetDate,
  schedule,
  currency = CURRENCIES.Usd,
  creditKind = CREDIT_KINDS.MONETARY,
  units,
}) => {
  const availableCredits = totalCredits - usedCredits;

  return (
    <Stack sx={{ gap: 3 }}>
      <VyDescriptionTitle
        title={formatCreditAmount(availableCredits, creditKind, currency, units)}
        cardSx={{
          '& .MuiCardHeader-title': {
            fontSize: '48px',
          },
        }}
        subTitle={
          <Stack direction="row" divider={<VyDivider orientation="vertical" flexItem />} sx={{ gap: '6px' }}>
            {isNotNullOrUndefined(resetDate) && (
              <Typography variant="body2">
                {`${schedule === CREDIT_SCHEDULES.ONE_TIME ? 'Expires on' : 'Resets'} ${formatDate(resetDate)}`}
              </Typography>
            )}
            {isNotNullOrUndefined(schedule) && <Typography variant="body2">{schedule}</Typography>}
          </Stack>
        }
      />
      <VyLinearProgress
        currentValue={usedCredits}
        totalValue={totalCredits}
        labelPlacement="bottom"
        progressColor="#5083FF"
        progressHeight="8px"
        renderLabel={() => (
          <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2">
              {`${formatCreditAmount(usedCredits, creditKind, currency, units)} used`}
            </Typography>
            <Typography variant="body2">
              {`${formatCreditAmount(totalCredits, creditKind, currency, units)} total`}
            </Typography>
          </Stack>
        )}
      />
    </Stack>
  );
};
